import { Link } from 'react-router-dom';

// Public (no-login) gallery of every custom page background.
// Lets you see all 7 backgrounds on the deployed preview without logging in.
const PAGES: { label: string; bg: string; blurb: string }[] = [
  { label: 'My Library', bg: '/bg/library.jpg', blurb: 'Your songs, playlists & lyrics' },
  { label: 'Create (Studio)', bg: '/bg/studio.jpg', blurb: 'Record, upload & generate' },
  { label: 'Compete (Arena)', bg: '/bg/arena.jpg', blurb: 'Live battles & rankings' },
  { label: 'Collabs', bg: '/bg/collabs.jpg', blurb: 'Find artists & build together' },
  { label: 'Messages', bg: '/bg/messages.jpg', blurb: 'Inbox & direct chat' },
  { label: 'Contract (Tiers)', bg: '/bg/tiers.jpg', blurb: 'Deals, tiers & access' },
  { label: 'Safety / Rules', bg: '/bg/safety.jpg', blurb: 'Community guidelines' },
];

export function BackgroundPreviewPage() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--midnight, #0a1342)', color: '#fff' }}>
      <div style={{
        position: 'sticky', top: 0, zIndex: 20,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '14px 22px',
        background: 'rgba(6,10,28,0.85)', backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
      }}>
        <strong style={{ fontFamily: 'Caveat, cursive', fontSize: 22, color: 'var(--gold-bright, #f2d36c)' }}>
          IAM-MUZIK · Page Backgrounds
        </strong>
        <Link to="/" style={{ color: 'var(--gold-bright, #f2d36c)', fontFamily: 'Caveat, cursive', fontSize: 18 }}>
          ← Back to home
        </Link>
      </div>

      <div style={{ padding: '26px 22px 60px', maxWidth: 1100, margin: '0 auto' }}>
        <p style={{ fontFamily: 'Caveat, cursive', fontSize: 20, color: 'rgba(255,255,255,0.7)', margin: '0 0 22px' }}>
          All 7 custom backgrounds, wired into their pages. Here's how each one looks.
        </p>

        {PAGES.map((p, i) => (
          <div key={p.label} style={{
            marginBottom: 26,
            borderRadius: 14,
            overflow: 'hidden',
            border: '1px solid rgba(255,255,255,0.08)',
            boxShadow: '0 10px 30px rgba(0,0,0,0.4)',
          }}>
            <div style={{
              position: 'relative',
              height: 340,
              backgroundImage: `linear-gradient(180deg, rgba(6,10,28,0.45) 0%, rgba(6,10,28,0.6) 55%, rgba(6,10,28,0.88) 100%), url(${p.bg})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              padding: 22,
            }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 12 }}>
                <span style={{
                  fontFamily: 'Caveat, cursive', fontSize: 30, color: 'var(--gold-bright, #f2d36c)', fontWeight: 700,
                }}>
                  {String(i + 1).padStart(2, '0')}.
                </span>
                <span style={{ fontFamily: 'Caveat, cursive', fontSize: 30, fontWeight: 700, color: '#fff' }}>
                  {p.label}
                </span>
              </div>
              <span style={{ fontFamily: 'Caveat, cursive', fontSize: 18, color: 'rgba(255,255,255,0.75)', marginLeft: 52 }}>
                {p.blurb}
              </span>
            </div>
          </div>
        ))}

        <p style={{ fontFamily: 'Caveat, cursive', fontSize: 17, color: 'rgba(255,255,255,0.5)', marginTop: 8 }}>
          These same backgrounds appear behind the real app pages when you're logged in.
        </p>
      </div>
    </div>
  );
}
